function custom(self, {
  message = '',
  type = 'is-white',
  position = 'is-bottom-right',
  actionText = '閉じる',
  indefinite = false,
  duration = 5000,
  queue = false,
  onAction = () => {}
}) {
  self.$snackbar.open({
    message,
    type,
    position,
    actionText,
    indefinite,
    onAction,
    duration,
    queue,
  })
}

function success(self, {message = ''}) {
  this.custom(self, {
    message,
    type: 'is-success',
    duration: 3000,
  })
}

function error(self, {message = ''}) {
  this.custom(self, {
    message,
    type: 'is-danger',
    duration: 6000,
  })
}

export default {
  custom,
  success,
  error
}